export default __webpack_public_path__ + "static/media/show-clothes-1.08ec15d2.webp";